import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react'

/**
 * Minimální router nad History API. Aplikace má pět obrazovek — plnohodnotná
 * routovací knihovna by tu byla závislost navíc bez užitku.
 */

type RouterValue = { path: string; navigate: (to: string) => void }
const RouterContext = createContext<RouterValue>({ path: '/', navigate: () => {} })

export function RouterProvider({ children }: { children: ReactNode }) {
  const [path, setPath] = useState(() => window.location.pathname)

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname)
    window.addEventListener('popstate', onPop)
    return () => window.removeEventListener('popstate', onPop)
  }, [])

  const navigate = useCallback((to: string) => {
    window.history.pushState({}, '', to)
    setPath(to)
    window.scrollTo(0, 0)
  }, [])

  return <RouterContext.Provider value={{ path, navigate }}>{children}</RouterContext.Provider>
}

export const useRouter = () => useContext(RouterContext)

export function Link({ to, children, ...props }: { to: string; children: ReactNode } & React.ComponentProps<'a'>) {
  const { navigate } = useRouter()
  return (
    <a
      href={to}
      onClick={(e) => {
        // ctrl/cmd-klik má pořád otevřít nový panel
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return
        e.preventDefault()
        navigate(to)
      }}
      {...props}
    >
      {children}
    </a>
  )
}

export function matchList(path: string): { id: string; print: boolean } | null {
  const m = /^\/lists\/([^/]+)(\/print)?\/?$/.exec(path)
  return m ? { id: m[1]!, print: m[2] !== undefined } : null
}
